import store from "../store/store";
import { createNotifier } from "../store/common/snackBarSlice";

/**
 * useSnackBar() for code outside React components (services, helpers,
 * interceptors). Same API: notify.success(text), notify.error(text), …
 */
export const notify = createNotifier(store.dispatch);
